<template>

  <section class="" :style="{ background: backgroundSection }">

    <div class="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 2xl:px-0">

      <h2 class="font-bold text-center h2" v-html="title"></h2>

      <div class="mt-4 text-center md:mt-8 textp" v-html="description"></div>

      <div class="grid grid-cols-2 gap-10 mt-8 sm-max:gap-2 md-max:space-y-8">

        <div v-for="(review, index) in reviews" :key="review.reviewerName" class="col-span-1 md-max:col-span-2">
          <div class="py-8 space-y-4 rounded-lg px-7 bg-grayReview md-only:p-8 md-max:p-4">
            <nuxt-img class="m-auto md-only:my-2" loading="lazy" alt="review-rating" width="148" height="23"
              :src="review.reviewImage"></nuxt-img>
            <h3 class="text-center h3 md-only:py-4" v-html="review.reviewTitle"></h3>
            <div class="text-center textp md-max:px-1 lg:h-50 pb-7 md-max:pb-4" v-html="review.reviewText">

            </div>
          </div>

          <div class="flex items-center justify-start mt-4 space-x-4">
            <nuxt-img class="" width="86" height="86" loading="lazy" alt="review-rating"
              :src="review.reviewerImage"></nuxt-img>
            <div>
              <div class="pb-1 text-lg font-bold leading-4 sm:text-22" v-html="review.reviewerName"></div>
              <div class="text-17" v-html="review.reviewerLocation"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-8 text-center md:mt-16">
        <button @click="scrollTo(scrollTarget)" class="text-white bnt-basic xs-max:w-full" :style="{ background: primaryColor }">
          order now </button>
      </div>
    </div>
  </section>
</template>


<script setup>

const props = defineProps({
  primaryColor: {
    type: String,
    default: "#e28831"
  },
  backgroundSection: {
    type: String,
    default: '#ebdfd3'
  },
  title: {
    type: String,
    default: '#The 5-star reviews are pouring in!'
  },
  description: {
    type: String,
    default: 'Discover countless stories of transformation and vitality from our community. Real people, real results – from athletes pushing their limits to professionals excelling in high-stakes environments, see how Cognition Mushroom Coffee has become an integral part of their success.'
  },
  scrollTarget: {
    type: String,
    default: "the-products"
  },
  reviews: {
    type: Array,
    default: () => [
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "No crash and constantly energy all day long",
        reviewText: "Can't believe how much this really helps synergize with the coffee. I make my coffee with coconut oil, butter, dash of honey and A2 creamer. Adding the mushrooms (that you can barely taste by the way) has helped increased the effect of the coffee with no crash and constant energy all day long, 10/10 would reccomend. Just ordered a 3 pack! It's now officially a staple.",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-mr.jpg",
        reviewerName: "Tom",
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "Got my brain back",
        reviewText: "Decided to try this coffee. Within 3 days my brain fog had lifted and I was able to communicate and express myself clearly without having to search for words. Give it a try - sure worked for me.",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "G Lawrence"
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "Unbelievable taste and results",
        reviewText: "I highly suggest this delicious and medicinal coffee. I feel incredibly energetic and focused. So happy to say it still tastes like a normal cup of LifeBoost coffee that I look forward to every morning.",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "JoAnn Alibrandi"
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "After trying other brands, this is by far my favorite",
        reviewText: "Just love the taste of this coffee! The mushrooms are not overwhelming and the coffee has a superior flavor. After trying other brands, this is by far my favorite!",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "Terry"
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "Exactly what I was waiting for",
        reviewText: "This is coffee is the BOMB.COM! Exactly what I was waiting for! The taste is awesome and super smooth! No jitters! It gives me the perfect amount of energy and increased concentration for the day! My new favorite coffee from Lifeboost! Fantastic Job Lifeboost!",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "Alex"
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "Feeling more focused",
        reviewText: "Since I started drinking Mushroom coffee first thing in the morning, I'm feeling more focused. I love LifeBoost because it tastes great and doesn't make me jittery. I traveled recently and drank whatever coffee was available. Wow, I couldn't believe how jittery I was after just one cup. With all Lifeboost coffee the taste is great and I feel alert without the jitters.",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-mr.jpg",
        reviewerName: "CF"
      },
    ]
  }
})

defineBuilderComponent({
  friendlyName: "Review with title",
  canHaveChildren: true,
  inputs: [
    {
      name: "primaryColor",
      type: "color",
      defaultValue: "#e28831"
    },
    { name: 'backgroundSection', type: 'color', defaultValue: '#ebdfd3' },
    {
      name: "title",
      type: "richText",
      defaultValue: "The 5-star reviews are pouring in!"
    },
    {
      name: "description",
      type: "richText",
      defaultValue: "Discover countless stories of transformation and vitality from our community. Real people, real results – from athletes pushing their limits to professionals excelling in high-stakes environments, see how Cognition Mushroom Coffee has become an integral part of their success."
    },
    {
      name: "scrollTarget",
      type: "text",
      defaultValue: "the-products"
    },
    {
      name: "reviews",
      type: "list",
      defaultValue: [
        {
          reviewImage: "/assets/images/freebag-rate-5.jpg",
          reviewTitle: "Blew my Mind! ",
          reviewText: "Can't believe how much this really helps synergize with the coffee. I make my coffee with coconut oil, butter, dash of honey and A2 creamer. Adding the mushrooms (that you can barely taste by the way) has helped increased the effect of the coffee with no crash and constant energy all day long, 10/10 would reccomend. Just ordered a 3 pack! It's now officially a staple.",
          reviewerImage: "/assets/images/freebag-dummy-testimonial-mr.jpg",
          reviewerName: "Tom",
        },
        {
          reviewImage: "/assets/images/freebag-rate-5.jpg",
          reviewTitle: "Got my brain back",
          reviewText: "Decided to try this coffee. Within 3 days my brain fog had lifted and I was able to communicate and express myself clearly without having to search for words. Give it a try - sure worked for me.",
          reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
          reviewerName: "G Lawrence"
        },
        {
          reviewImage: "/assets/images/freebag-rate-5.jpg",
          reviewTitle: "Unbelievable taste and results",
          reviewText: "I highly suggest this delicious and medicinal coffee. I feel incredibly energetic and focused. So happy to say it still tastes like a normal cup of LifeBoost coffee that I look forward to every morning.",
          reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
          reviewerName: "JoAnn Alibrandi"
        },
        {
          reviewImage: "/assets/images/freebag-rate-5.jpg",
          reviewTitle: "After trying other brands, this is by far my favorite",
          reviewText: "Just love the taste of this coffee! The mushrooms are not overwhelming and the coffee has a superior flavor. After trying other brands, this is by far my favorite!",
          reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
          reviewerName: "Terry"
        },
        {
          reviewImage: "/assets/images/freebag-rate-5.jpg",
          reviewTitle: "Exactly what I was waiting for",
          reviewText: "This is coffee is the BOMB.COM! Exactly what I was waiting for! The taste is awesome and super smooth! No jitters! It gives me the perfect amount of energy and increased concentration for the day! My new favorite coffee from Lifeboost! Fantastic Job Lifeboost!",
          reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
          reviewerName: "Alex"
        },
        {
          reviewImage: "/assets/images/freebag-rate-5.jpg",
          reviewTitle: "Feeling more focused",
          reviewText: "Since I started drinking Mushroom coffee first thing in the morning, I'm feeling more focused. I love LifeBoost because it tastes great and doesn't make me jittery. I traveled recently and drank whatever coffee was available. Wow, I couldn't believe how jittery I was after just one cup. With all Lifeboost coffee the taste is great and I feel alert without the jitters.",
          reviewerImage: "/assets/images/freebag-dummy-testimonial-mr.jpg",
          reviewerName: "CF"
        },
      ],
      subFields: [
        {
          name: "reviewImage",
          type: "file",
          allowedFileTypes: [
            "jpeg",
            "jpg",
            "png",
            "svg"
          ],
          defaultValue: "/assets/images/freebag-rate-5.jpg",
          required: true
        },
        {
          name: "reviewTitle",
          type: "richText",
          defaultValue: "review title"
        },
        {
          name: "reviewText",
          type: "richText",
          defaultValue: "review text"
        },
        {
          name: "reviewerImage",
          type: "file",
          allowedFileTypes: [
            "jpeg",
            "jpg",
            "png",
            "svg"
          ],
          defaultValue: "/assets/images/freebag-dummy-testimonial-ms.jpg",
          required: true
        },
        {
          name: "reviewerName",
          type: "richText",
          defaultValue: "Reviewer Name"
        },
        {
          name: "reviewerLocation",
          type: "richText",
          defaultValue: "Reviewer Location"
        }
      ]
    }
  ]
});
</script>